document.addEventListener('turbo:load', () => {
  initializeDonorMap();
});

function initializeDonorMap() {
  const mapInfoBox = document.getElementById('map_info_box');
  const stateGroups = document.querySelectorAll('#donor_map g[data-amount_cents]');

  if (!mapInfoBox || !stateGroups.length) return;

  console.log("Loading maps/donor_map.js");

  // Initially hide the info box
  mapInfoBox.style.display = 'none';
  mapInfoBox.style.position = 'absolute';
  mapInfoBox.style.pointerEvents = 'none';
  mapInfoBox.style.zIndex = '1000';

  stateGroups.forEach(stateGroup => {
    // Show info box on hover
    stateGroup.addEventListener('mouseenter', function() {
      showStateInfo(this);
    });

    // Hide info box when leaving state
    stateGroup.addEventListener('mouseleave', function() {
      mapInfoBox.style.display = 'none';
    });
  });

  // Follow mouse cursor - use document since we're positioning relative to the page
  document.addEventListener('mousemove', function(e) {
    if (mapInfoBox.style.display === 'block') {
      updateInfoBoxPosition(e);
    }
  });

  function showStateInfo(stateElement) {
    const stateId = stateElement.id;
    const amountCents = parseInt(stateElement.dataset.amount_cents) || 0;
    const count = parseInt(stateElement.dataset.count) || 0;

    // Format state name (convert underscores to spaces and title case)
    const stateName = formatStateName(stateId);

    // Update the content
    document.getElementById('map_info_box_state').textContent = stateName;
    document.getElementById('map_info_box_count').textContent = count.toLocaleString();

    // Update amount if the element exists (conditional rendering)
    const amountElement = document.getElementById('map_info_box_amount');
    if (amountElement) {
      const amountDollars = formatCurrency(amountCents);
      amountElement.textContent = amountDollars;
    }

    // Show the info box
    mapInfoBox.style.display = 'block';
  }

  function updateInfoBoxPosition(event) {
    // Position relative to the viewport with some offset
    const x = event.pageX + 10;
    const y = event.pageY - 10;

    mapInfoBox.style.left = x + 'px';
    mapInfoBox.style.top = y + 'px';
  }

  function formatStateName(stateId) {
    return stateId
      .replace(/_/g, ' ')
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  function formatCurrency(amountCents) {
    return (amountCents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
}